import { FormValues } from "@/pages/LoginPage/login-page.types";

export const initialValues: FormValues = {
    username: "",
    password: "",
    rememberMe: true,
};
